<template>
  <span>{{ tweeningValue }}</span>
</template>

<script>

import TWEEN from '@tweenjs/tween.js'

export default {

  name: 'animated-number',

  props: {
    value: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      tweeningValue: 0
    }
  },

  watch: {
    value: function (newValue, oldValue) {
      if(newValue != oldValue) {
        this.tween(oldValue, newValue)
      }
    }
  },

  mounted: function () {
    this.tween(0, this.value)
  },

  methods: {

    formatNumber(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },

    tween: function (startValue, endValue) {

      var vm = this

      function animate () {
        if (TWEEN.update()) {
          requestAnimationFrame(animate)
        }
      }

      new TWEEN.Tween({ tweeningValue: startValue })
        .to({ tweeningValue: endValue }, 500)
        .onUpdate(function (res) {
          vm.tweeningValue = vm.formatNumber(res.tweeningValue.toFixed(0))
        })
        .start()

      animate()
    }
  }

}
</script>>



// WEBPACK FOOTER //
// src/components/AnimatedNumber.vue